import { atom } from 'recoil';

export const successFullModalAtom = atom({
  key: 'successFullModalAtom',
  default: false,
});
